import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* changePassword(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_REQUEST
    });

    yield call(Http.put, `contact/password`, action.payload?.data);

    yield put({
      type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-action-successful"),
        type: "success"
      }
    });

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChangePassword() {
  yield takeEvery(Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_START, changePassword);
}
